module.exports = __webpack_public_path__ + "mg.b7c0a18146665d103f8d.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/mg.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/mg.svg
// module chunks = styles